import script from "./TrafficChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficChart.vue?vue&type=script&setup=true&lang=js"

import "./TrafficChart.vue?vue&type=style&index=0&id=565307b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565307b1"]])

export default __exports__